import { useRef } from "react";
import { useLocation } from "react-router";

import styles from "@components/menus/MenuItem.module.css";
import MenuItemText from "@components/menus/MenuItemText";
import Icon from "@components/text/Icon";
import InternalLink from "@components/typography/InternalLink";
import { IconName } from "@utils/iconUtils";

type MenuItemProps = {
  iconName: IconName;
  onClick?: () => void;
  text: string;
  to: string;
  unread?: boolean;
};

const MenuItem = ({ iconName, onClick, text, to, unread = false }: MenuItemProps) => {
  const location = useLocation();

  const menuItemRef = useRef<HTMLDivElement>(null);

  const current = location.pathname.includes(to.split("?")[0]);

  const linkClasses = [styles.menuItemLink];
  if (current) {
    linkClasses.push(styles.current);
  } else {
    linkClasses.push(styles.notCurrent);
  }

  return (
    <InternalLink
      aria-current={current ? "page" : undefined}
      className={linkClasses.join(" ")}
      expand
      linkEventCreateVariables={{}}
      onClick={onClick}
      stylized={false}
      tabIndex={current ? -1 : undefined}
      to={to}
    >
      <div className={styles.menuItem} data-test="nav-item" ref={menuItemRef}>
        <div>
          <Icon color={current ? "primary" : "white"} icon={iconName} />
        </div>
        <MenuItemText selected={current} text={text} />
        {unread && <Icon color="danger-300" icon="circleExclamation" spacingStart />}
        {current && <div className={`${styles.selectedBar} ion-hide-lg-down`} />}
      </div>
    </InternalLink>
  );
};

export default MenuItem;
